export default __webpack_public_path__ + "static/media/send-backward.6b765011.svg";